/* global I18n */

import React from "react"

function LearnableTooltip({data_set, total}) {
  return (
    <div className="learnable-tooltip">
      <div className="tooltip-title">
        <span className="bold">
          {total}
          {"\u00A0"}
          {I18n.t("js.new_embedded_quiz.study_summary.total")}
        </span>
      </div>
      <div className="tooltip-item">
        <span className="bold">{data_set[0]}</span>
        {"\u00A0"}
        {I18n.t("js.new_embedded_quiz.study_summary.learning")}
      </div>
      <div className="tooltip-item">
        <span className="bold">{data_set[1]}</span>
        {"\u00A0"}
        {I18n.t("js.new_embedded_quiz.study_summary.mastering")}
      </div>
      <div className="tooltip-item">
        <span className="bold">{data_set[2]}</span>
        {"\u00A0"}
        {I18n.t("js.new_embedded_quiz.study_summary.mastery")}
      </div>
    </div>
  )
}

export default LearnableTooltip
